import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { usePlatformAdminStatus } from '@/hooks/usePlatformAdmin'

// Independent of tenant membership/role — a platform admin may or may not
// also own a tenant. Intentionally NOT nested under TenantGuard.
export function PlatformAdminGuard({ children }: { children: ReactNode }) {
  const { data: isAdmin, isLoading } = usePlatformAdminStatus()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-violet-600 border-t-transparent" />
      </div>
    )
  }

  if (!isAdmin) return <Navigate to="/" replace />

  return <>{children}</>
}
